export const icons = {
  calendar: "fa fa-calendar",
  menu: "fa fa-bars",
  close: "fa fa-times",
  avatar: "fa fa-user-circle",
  file: "fa fa-file",
  search: "fa fa-search",
  user: "fa fa-user",
  dashboard: "fa fa-tachometer",
  settings: "fa fa-cogs",
  money: "fa fa-dollar",
  tasks: "fa fa-tasks",
  arrowLeft: "fa fa-arrow-left",
  arrowRight: "fa fa-arrow-right",
  back: "fa fa-angle-left",
  next: "fa fa-angle-right",
  signOut: "fa fa-sign-out",
  signIn: "fa fa-sign-in",
  empty: "fa fa-tags",
  error: "fa fa-exclamation",
  delete: "fa fa-trash",
  loading: "fa fa-spinner",
  star: "fa fa-star",
  feedback: "fa fa-feed",
  lock: "fa fa-lock",
  message: "fa fa-message",
  send: "fa fa-paper-plane",
  caret: "fa fa-ellipsis-vertical",
};
